import React from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Box, Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import AuthCard from 'components/Cards/AuthCard';
import ErrorMessageBuilder from '../ErrorMessages/ErrorMessageBuilder';

const useStyles = makeStyles((theme) => ({
  instructions: {
    ...theme.typography.subtitle2,
  },
  title: {
    ...theme.typography.h5,
    color: theme.palette.error.main,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
}));

const PasswordResetErrorConditions = (error) => {
  const unpackedError = error.error;
  const classes = useStyles();
  const { t } = useTranslation();
  let errorComponent = <Box />;
  const now = new Date();
  if (error !== undefined) {
    if (unpackedError?.statusCode === 401 && unpackedError?.message === 'Token is expired') {
      errorComponent = (
        <ErrorMessageBuilder
          failureTitle={t('password_reset_failure')}
          failureMessage={t('page_expiration_after_send')}
        />
      );
    } else if (now > unpackedError.expiration) {
      errorComponent = (
        <ErrorMessageBuilder expirationTime={unpackedError?.expiration.toString()} failureMessage={t('page_expired')} />
      );
    } else if (unpackedError?.statusCode === 401 && unpackedError?.message === 'Token is invalid') {
      errorComponent = <ErrorMessageBuilder failureMessage={t('password_reset_failure')} />;
    } else if (unpackedError?.statusCode === 401 && unpackedError?.message === 'Token is missing') {
      errorComponent = <ErrorMessageBuilder failureMessage={t('password_reset_invalid')} />;
    } else {
      errorComponent = (
        <ErrorMessageBuilder
          failureTitle={t('password_reset_failure')}
          failureMessage={t('password_reset_failure_unknown')}
        />
      );
    }
  }

  return (
    <AuthCard
      footer={
        <Grid container direction="row" justifyContent="space-evenly" spacing={4}>
          <Grid item xs={6}>
            <Box className={classes.footer}>
              <Button size="small" component={Link} to="/resetPasswordRequest">
                {t('return_to_login')}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className={classes.footer}>
              <Button size="small" component={Link} to="/resetPasswordRequest">
                {t('reset_password')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      }
    >
      <Grid container direction="row" justifyContent="space-evenly" spacing={4}>
        {errorComponent}
        <Grid item xs={12}>
          <Box component="div" className={classes.root}>
            <Typography className={classes.instructions}>{t('reset_password_new_link')}</Typography>
          </Box>
        </Grid>
      </Grid>
    </AuthCard>
  );
};

PasswordResetErrorConditions.propTypes = {
  error: PropTypes.object.isRequired,
};

PasswordResetErrorConditions.defaultProps = {};

export default PasswordResetErrorConditions;
